import React, { Component } from 'react';

class Projects extends  Component{
    render(){
        return(
            <div style={{marginTop:'64px'}}><h1>Projects Page</h1></div>
        )
            
        
    }

}
export default Projects;